module.exports = __webpack_public_path__ + "assets/font/MiSans-Regular-f03ebbc2.woff2";